export const emptyUrl = 'about:blank';

export const aviatrixRealms = ['Russia'];

export const aviatrixCountryAlpha2IsoCode = 'RU';

export const aviatrixCurrency = 'RUB';

export const GAMES_SECTION_LOAD_SIZE = 60;
